import React, { useState } from "react";
import config from "../../config";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {
  Download,
  Fullscreen,
  Thumbnails,
  Video,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Document from "../DocumentsPage/Document";

const EducationProgramField = ({ field }) => {
  const [index, setIndex] = useState(-1);

  const handleImageClick = (indexVar) => {
    setIndex(indexVar);
  };

  //vytvoreni noveho pole pro media z duvodu, ze lightbox potrebuje jiny format JSONU nez jaky dostaneme ze strapi
  //kontrola zdali jsou tam data - jelikoz pole medii je nepovinne
  const galleryData = field?.images ?? [];
  const mediaEdited = [];

  for (let i = 0; i < galleryData.length; i++) {
    const item = galleryData[i];
    // kontrola nejdulezitejsich hodnot kdyby nahodou byl null
    const mime = item?.mime ?? "";
    const url = item?.url ?? "";
    const mediumUrl = item?.formats?.medium?.url ?? "";
    if (mime.startsWith("image")) {
      mediaEdited.push({
        id: item.id,
        type: "image",
        alternativeText: item.alternativeText,
        src: `${config.api}${url}`,
        medium: `${config.api}${mediumUrl}`,
      });
    } else if (mime.startsWith("video")) {
      mediaEdited.push({
        id: item.id,
        type: "video",
        alternativeText: item.alternativeText,
        title: item.title || "Video Title",
        description: item.description || "Video Description",
        width: 1280, // Adjust as needed
        height: 720, // Adjust as needed
        poster: `/images/video-icon.png`, // default poster
        sources: [
          {
            src: `${config.api}${url}`,
            type: mime,
          },
        ],
      });
    }
  }
  return (
    <div className="mt-4 mb-5 study-field" key={field.id}>
      <h2 className="text-center">{field.name}</h2>
      <BlocksRenderer
        content={Array.isArray(field?.text) ? field.text : []}
      ></BlocksRenderer>
      {field?.documents?.map((document) => (
        <div className="news-doc" key={document.documentId}>
          <Document name={document.name} fileUrl={document.url} />
        </div>
      ))}
      <Lightbox
        plugins={[Download, Fullscreen, Thumbnails, Video]}
        open={index >= 0}
        close={() => setIndex(-1)}
        index={index}
        slides={mediaEdited}
      />

      {/* vykreslovani medii podle toho jestli to je video nebo obrazek, na videu nastaven defaultni nahled */}
      <div className="container d-flex flex-wrap justify-content-center">
        {mediaEdited?.slice(0, 5).map((media, index) => (
          <div
            key={index}
            className="m-2 col-10 col-md-3 d-flex justify-content-center"
          >
            {media.type === "image" ? (
              <img
                src={media.src}
                onClick={() => setIndex(index)}
                alt={media.alternativeText}
                className="media-thumbnail media-gallery"
                style={{ cursor: "pointer" }}
              />
            ) : (
              <img
                src="/images/video-icon.png"
                onClick={() => setIndex(index)}
                alt={media.alternativeText}
                className="media-thumbnail media-gallery"
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
        ))}
        {mediaEdited?.length > 5 && (
          <div className="show-more-images-container">
            <button
              className="show-more-images-button"
              onClick={() => handleImageClick(5)}
            >
              Více fotografií
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EducationProgramField;
